import { FixMeLater } from '../temporary-types';
import { DATE_FORMATS, DATE_TIME_FORMATS, TIME_FORMATS } from '../constants/dateFormats';
import moment from 'moment-timezone';

export const getDateFromNativeDateObject = (date: FixMeLater): string => {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) {
    month = `0${month}`;
  }

  if (day.length < 2) {
    day = `0${day}`;
  }

  return [year, month, day].join('-');
};

export const getFormattedDate = (date, time = null,format = DATE_FORMATS['DD.MM.YYYY']) => {
  if(!date) return '';

  if(!time) {
    return moment(date).format(format);
  }

  const combinedDate = combineDateTimeInUTC(date, time);

  const localDateTime = moment.utc(combinedDate).local();

  return moment(localDateTime).format(format);
}

export const getFormattedTime = (date, time, format = TIME_FORMATS['HH.mm']) => {
  const combinedDate = combineDateTimeInUTC(date, time);

  const localDateTime = moment.utc(combinedDate).local();

  return moment(localDateTime).format(format);}

export const combineDateTimeInUTC = (date: string, time: string): string => { 
  return `${date}T${time}:00Z`;

}

export const getFormattedDateTime = (dateTime: string, format = DATE_TIME_FORMATS['DD.MM.YYYY HH.mm A']) => {
  return moment(dateTime).format(format);
}